module.exports = __webpack_public_path__ + "img/logo_black.d7e392f2.png";